import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createCategoryCoupon',
    serviceName: 'unitadmin',
    query: gql`
      mutation createCategoryCoupon(
        $title: String!
        $is_active: Int
        $unit_id: String
        $total_amount: String
      ) {
        createCategoryCoupon(
          title: $title
          unit_id: $unit_id
          is_active: $is_active
          total_amount: $total_amount
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
